// Picker.js - A wrapper to fix the appearance of the web-position of the right-arrow drop-down indicator.
import { Picker } from "@react-native-picker/picker";  // https://www.npmjs.com/package/@react-native-picker/picker
import { View } from "react-native";

const PickerWrapper = ({...props})=>{
  const _theme = window.main.theme;
  props.style.borderWidth = 0;
  return (
    <View style={{..._theme.textInput,paddingVertical:0,paddingLeft:0,paddingRight:10,...props.wrapperStyle}}>
      <Picker {...props}>{props.children}</Picker>
    </View>
  );
};

PickerWrapper.Item = Picker.Item;

export default PickerWrapper;
